export default __webpack_public_path__ + "static/media/bothamJean.120b65cc.png";